module.exports = __webpack_public_path__ + "img/big_banner1.8682bdc4.png";